import * as yup from 'yup'
import { InferType } from 'yup'
import {
	TREATMENT_SCHEMA_DESCRIPTION_MAX_LENGTH,
	TREATMENT_SCHEMA_TITLE_MAX_LENGTH,
} from '../../utils/treatmentSchemaDisplay'

export const treatmentSchema = yup.object({
	treatments: yup
		.array()
		.of(
			yup.object({
				title: yup
					.string()
					.trim()
					.required('Введите наименование схемы лечения')
					.max(
						TREATMENT_SCHEMA_TITLE_MAX_LENGTH,
						`Не больше ${TREATMENT_SCHEMA_TITLE_MAX_LENGTH} символов`,
					),
				description: yup
					.string()
					.trim()
					.required('Введите описание схемы лечения')
					.max(
						TREATMENT_SCHEMA_DESCRIPTION_MAX_LENGTH,
						`Не больше ${TREATMENT_SCHEMA_DESCRIPTION_MAX_LENGTH} символов`,
					),
				duration: yup
					.string()
					.required('Введите длительность лечения')
					.matches(/^[1-9]\d*$/, 'Введите целое число больше 0'),
				examinationInterval: yup
					.string()
					.required('Введите периодичность осмотров')
					.matches(/^[1-9]\d*$/, 'Введите целое число больше 0'),
				rejectMilk: yup.boolean(),
				milkRejectDays: yup.string().when('rejectMilk', {
					is: true,
					then: schema =>
						schema
							.required('Введите период выбраковки молока')
							.matches(/^[1-9]\d*$/, 'Введите целое число больше 0'),
					otherwise: schema => schema,
				}),
				selectedDiagnose: yup
					.array()
					.of(yup.number())
					.min(1, 'Выберите диагноз'),
			}),
		)
		.min(1, 'Нужно добавить хотя бы одну схему'),
})

export type TreatmentFormValues = InferType<typeof treatmentSchema>
